import { type BlogPostResponse } from '@/features/blog/types/blog-post-response-types';
import { type BlogPost } from '@/features/blog/types/blog-post-types';

export default function BlogPostAdapter(blogPostResponse: BlogPostResponse): BlogPost {
  let imgUrlCropped: BlogPost['imgUrl'] = null;

  if (blogPostResponse.feature_image) {
    // change size of image
    imgUrlCropped = blogPostResponse.feature_image.replaceAll(/w=\d+/gm, 'w=373');
  }

  return {
    description: blogPostResponse.excerpt,
    id: blogPostResponse.id,
    imgUrl: imgUrlCropped,
    link: blogPostResponse.url,
    title: blogPostResponse.title,
    type: 'blogPost',
  };
}
